import { datajs, datajsAll, trapFocus, hasScollState } from '../shared/utils';

export default class ContactFormModal {
	static init() {
		const contactFormModalElement = datajs('contact-form-modal');
		const anchorLinkContactFormModalTriggers = document.querySelectorAll('[href*="#contact-form"]');
		let contactFormModalTriggers = datajsAll('toggle-contact-form');
		let isTransitioning = false;

		contactFormModalTriggers = [...contactFormModalTriggers, ...anchorLinkContactFormModalTriggers];

		if (!contactFormModalElement) {
			return;
		}

		const toggleContactFormModal = (e) => {
			e.preventDefault();

			window.requestAnimationFrame(showContactFormModal);
		};

		const showContactFormModal = () => {
			if (isTransitioning) {
				return false;
			}

			isTransitioning = true;

			trapFocus(document.getElementById('contact-form-modal'));

			// Transition CSS class 1
			document.body.classList.add('has-activated-contact-form');

			// Transition CSS class 2
			setTimeout(function () {
				document.body.classList.add('has-contact-form');

				if (hasScollState()) {
					document.body.classList.remove('is-scrollingUp');
				}

				isTransitioning = false;
			}, 10);

			return false;
		};

		// Toggle off canvas menu
		if (contactFormModalElement) {
			contactFormModalTriggers.forEach((trigger) => {
				trigger.addEventListener('click', toggleContactFormModal);
			});
		}
	}
}
